import { Component } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgClass } from '@angular/common';
import { ScIconPipe } from '@core/jss-utils';

import { BasicContentVariantInheritableComponent } from '../basic-content-variant.inheritable.component';
import { ComposableCardComponent } from '../../../composables/card/card.component';
import { BasicContentPartialTopBetweenComponent } from '../../partials/basic-content-partial-top-between/basic-content-partial-top-between.component';

@Component({
  selector: 'wl-basic-content-variant-vertical-icon',
  templateUrl: './basic-content-variant-vertical-icon.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    ComposableCardComponent,
    BasicContentPartialTopBetweenComponent,
    FaIconComponent,
    NgClass,
    ScIconPipe,
  ],
})
export class BasicContentVariantVerticalIconComponent extends BasicContentVariantInheritableComponent {}
